import script from "./TorneosView.vue?vue&type=script&setup=true&lang=ts"
export * from "./TorneosView.vue?vue&type=script&setup=true&lang=ts"

import "./TorneosView.vue?vue&type=style&index=0&id=1847a33d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1847a33d"]])

export default __exports__